<template>
  <ul class="speaker-wrap is-multiline columns is-mobile container">
    <Speaker v-for="(speaker, key) in speakers['list']"
             :data="speaker"
             :key="key"
             class="speaker column is-one-quarter-desktop is-one-third-tablet is-half-mobile clearfix"
             v-if="speaker['name']"
    ></Speaker>
  </ul>
</template>

<script>
  import Speaker from './components/personage'
  export default {
    components: {
      Speaker
    },
    props: [
      'speakers'
    ],
    data () {
      return {
      }
    }
  }
</script>

<style scoped lang="sass">
  @import "style/variable"
  .speaker-wrap
    background-color: $main-background
    .speaker
      height: auto
</style>



// WEBPACK FOOTER //
// src/speakers.vue